<template>
  <div class="login fill-height px2">
    <div class="center">
      <img class="login-logo mt3" src="../assets/logo.png">
      <h3 class="h3 text-warning mt3">东阳光评分系统</h3>
    </div>
    <div ref="form" class="login-form flex flex-column items-center mt2_5">
      <van-field
        v-model="phone"
        ref="phone"
        class="login-phone width-per90"
        label="+86"
        type="tel"
        maxlength="11"
        placeholder="请输入您的手机号码"
        @input="handleInput"
        @blur="handleBlur"
        @focus="handleFocus"
        @keyup.enter="handleEnter"
      />
      <van-button
        ref="loginBtn"
        class="login-btn mt3 width-per90"
        :loading="isLoading"
        @click="getMeets"
      >进入会议</van-button>
    </div>
    <van-dialog
      v-if="showMeets"
      v-model="showMeets"
      class="center pt1"
      :before-close="handleBeforeClose"
      confirmButtonText="进入会议"
    >
      <span class="h5 bold text-light">请选择要参加的会议</span>
      <div class="py2">
        <van-picker ref="meets" :columns="meets"/>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { setToken } from '@/utils/user'
import { setMeet } from '@/utils/score'
import { handleToNumber } from '@/utils'
export default {
  name: 'Login',
  data() {
    return {
      phone: '',
      meets: [],
      isLoading: false,
      showMeets: false
    }
  },
  methods: {
    validate() {
      if (this.phone.length !== 11) {
        setTimeout(() => {
          this.$toast({
            message: this.phone.length
              ? '请输入有效的手机号码'
              : '请输入手机号码',
            duration: 1000
          })
        }, 200)
        this.$nextTick(() => {
          this.$refs['phone'].focus()
        })
        return false
      }
      return true
    },
    async getMeets() {
      if (!this.validate()) {
        return
      }
      try {
        this.isLoading = true
        let meets = await this.$http.get(`meets?tel=${this.phone}`)
        this.isLoading = false
        if (!meets || !meets.length) {
          throw new Error()
        }
        this.meets = meets.map(meet => ({
          value: meet.id,
          text: meet.meetname
        }))
        if (meets.length === 1) {
          this.login({ id: this.meets[0].value, name: this.meets[0].text })
        } else {
          this.showMeets = true
        }
      } catch (error) {
        this.isLoading = false
        this.$toast({
          type: 'fail',
          message: `${error.message}`,
          duration: 1500
        })
      }
    },
    login(meet) {
      this.isLoading = true
      return this.$http
        .post(`login?tel=${this.phone}&meetid=${meet.id}`)
        .then(token => {
          this.isLoading = false
          setToken(token)
          this.$router.push({ name: 'home' })
          setMeet(meet.name)
        })
        .catch(error => {
          this.isLoading = false
          this.$toast('登录失败')
          throw error
        })
    },
    handleFocus() {
      setTimeout(() => {
        window.scrollTo(0, 100)
      }, 160)
    },
    handleEnter() {
      this.getMeets()
      this.$refs['phone'].blur()
    },
    handleBlur() {
      this.$nextTick(() => {
        window.scrollTo(0, 0)
      })
    },
    handleBeforeClose(action, done) {
      if (action === 'confirm') {
        let selectedMeet = this.$refs['meets'].getValues()[0]
        this.login({ id: selectedMeet.value, name: selectedMeet.text })
          .then(() => {
            done()
          })
          .catch(() => {
            done(false)
          })
      }
    },
    handleInput(value) {
      this.phone = handleToNumber({ value })
    }
  }
}
</script>

<style lang="less" scoped>
.login {
  background-image: linear-gradient(
    rgba(255, 255, 255, 0.09) 74%,
    rgba(0, 156, 238, 0.3) 100%
  );
  .login-logo {
    width: 100px;
    height: 100px;
  }
  .login-form {
    .login-phone {
      &::after {
        left: 0;
        border-bottom: 1px solid @text-light;
      }
      &:focus-within {
        &::after {
          border-bottom: 2px solid @primary;
        }
      }
    }
    .login-btn {
      background: @primary;
      color: @white;
    }
  }
}
</style>
